import * as m from "#/paraglide/messages";
import {
  createBackendFailureMessageResolver,
  readBackendFailure,
} from "#/shared/lib/backend-api";

import {
  getHomeMetricsOperation,
  type GetHomeMetricsOperation,
} from "../api/get-home-metrics";

const resolveFailureMessage =
  createBackendFailureMessageResolver<GetHomeMetricsOperation>({
    forbidden: () => m.home_metrics_failure_forbidden(),
    network: () => m.home_metrics_failure_network(),
    rejected: () => m.home_metrics_failure_rejected(),
    schema: () => m.home_metrics_failure_schema(),
    unexpected: () => m.home_metrics_failure_unexpected(),
  });

/**
 * 把读 Home 指标时抛出的任意错误翻成一句可展示文案。
 * 不是本 feature 的失败时返回 null，界面据此保持安静。
 */
export function readHomeMetricsFailureMessage(error: unknown): string | null {
  return resolveFailureMessage(
    readBackendFailure(error, [getHomeMetricsOperation]),
  );
}
